import Vue from 'vue'
import Router from 'vue-router'
import { menu } from '../store/menu'
import lazyLoading from '../utils/lazyLoading'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Home',
      path: '/',
      component: lazyLoading('Home')
    },
    ...generateRoutesFromMenu(menu.state.items)
  ]
})

function generateRoutesFromMenu (menu = [], routes = [], parent) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path && (item.createroutes || (parent && parent.createroutes))) {
      routes.push(item)
    }
    if (!item.component && item.children && item.children.length > 0 && item.createroutes) {
      generateRoutesFromMenu(item.children, routes, item)
    }
  }
  return routes
}



// WEBPACK FOOTER //
// ./src/router/index.js